import Moment from "moment";
import * as R from "ramda";
import React, {Component} from "react";
import Api from "../../../../../Services/Api";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Button from "../../../../../modules/commons/Button";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../../../modules/popup/SimplePrintTable";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import ReceivingUnitDGIDetail from "./receivingUnitDGIDetail";
import ReceivingUnitDGIFilter from "./receivingUnitDGIFilter";
import ReceivingUnitDGISearch from "./receivingUnitDGISearch";
import { saveAs } from "file-saver";
import moment from "moment";
import FlexView from "react-flexview";
import { getUserAccess } from "../../../../../Services/Utils";

class ReceivingUnitDGI extends Component {
    tableColumns = [
        {
            name: "tanggalSl",
            label: "Tanggal SL",
            options: {
                customBodyRender: (val) => <>{Moment(val).format("DD-MM-YYYY")}</>,
                sort: false,
            },
        },
        {
            name: "slNo",
            label: "No. Shipping List (SL)",
            options: {
                sort: false,
            },
        },
        {
            name: "invoiceNo",
            label: "No. Invoice",
            options: {
                sort: false,
            },
        },
        {
            name: "jumlah",
            label: "Jumlah",
            options: {
                sort: false,
            },
        },
        {
            name: "slNo",
            label: "Aksi",
            options: {
                customBodyRender: (val) => {
                    return (
                         <FlexView vAlignContent="center" style={{gap: "15px"}}>
                            <Button className="btnAct" onClick={() => this.handleModalDetailVisibility(val, "", "view")}>
                                <i
                                    className="fa fa-lg fa-eye"
                                    style={{
                                        fontSize: 20,
                                        color: "red"
                                    }}
                                />
                            </Button>
                            <Button className="btnAct"  disabled={this.state.userAccess && this.state.userAccess.createAccess ? false : true}  onClick={() => this.handleModalDetailVisibility(val, "", "proses")}>
                                <i
                                    className="fa fa-lg fa-paper-plane"
                                    style={{
                                        fontSize: 20,
                                        color: this.state.userAccess && this.state.userAccess.createAccess ? "red" : "black"
                                    }}
                                />
                            </Button>
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.slDateInitialValue = {
            endDateSL: moment(new Date()).format('YYYY-MM-DD'),
            startDateSL: moment(new Date()).format('YYYY-MM-DD'),
        };
        this.state = {
            printVisible: false,
            loading: false,
            filterVisible: false,
            detailVisible: false,
            selectedData: null,
            submittedFilterData: {},
            filterData: {},
            searchData: {
                ...this.slDateInitialValue,
            },
            kodeCabang: null,
            pagination: {
                totalData: 1,
                page: 1,
                limit: 5,
            },
            cabangOptions: [],
            dataTable: [],
            skipNextPaginationFetch:false,
            actionType: null
        };
    }

    formatDate(value) {
        return Moment(value || new Date()).format("YYYY-MM-DD");
    }

    async componentDidMount() {
        this.handleTriggerLoading();

        let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
        if (res.ok) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            ).map(item => mapToObjectDDL(item.namaDealer, item.kodeCabang));

            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    cabangOptions: filteredData,
                    kodeCabang: filteredData[0]
                }));
            }
            await this.fetchData({
              kodeCabang: filteredData[0]?.value,
              startDateSL: this.formatDate(),
              endDateSL: this.formatDate(),
            })
        }
        this.handleTriggerLoading();
    }

    async componentDidUpdate(_, prevState) {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
            prevState.pagination.limit !== this.state.pagination.limit) && !this.state.skipNextPaginationFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
        if(this.state.skipNextPaginationFetch){
            this.setState({ skipNextPaginationFetch: false})
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        const response = await Api.create("NAGAMAS_DGI").getAllReceivingDGI({
            filter: {
                kodeCabang: this.state.kodeCabang.value,
                ...filter,
            },
            page,
            limit,
        });
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: !R.isEmpty(response.data.data) ? response.data.data : [],
                userAccess: getUserAccess(this.props.menuAccess, this.state.kodeCabang.value),
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                },
            }));
        }
    };

    handleModalFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleModalDetailVisibility = async (slNo, action='', type) => {
        if (slNo) {
            const response = await Api.create("NAGAMAS_DGI").getReceivingDGIDetail(
                this.state.kodeCabang.value,
                slNo
            );
            if (response.ok && !R.isNil(response.data.data)) {
                this.setState((prevState) => ({
                    ...prevState,
                    selectedData: response.data.data,
                    actionType: type,
                    detailVisible: !prevState.detailVisible,
                }));
            }
        } else {
            if(action==='refresh'){
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: null,
                    detailVisible: !prevValue.detailVisible,
                    skipNextPaginationFetch: true
                }));

                this.handleTriggerLoading();
                await this.fetchData(
                    this.state.submittedFilterData,
                    this.state.pagination.page,
                    this.state.pagination.limit
                );
                this.handleTriggerLoading();
            }else{
                this.setState((prevState) => ({
                    ...prevState,
                    selectedData: null,
                    detailVisible: !prevState.detailVisible,
                }));
            }
            
        }
    };

    handleResetPagination = () =>{
        this.setState((prev) => ({
          ...prev,
          pagination: {
            totalData: 0,
            page: 1,
            limit: 5,
          },
        }));
    }

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
          ...prevValue,
          loading: true,
          searchData: {
            endDateSL: null,
            startDateSL: null,
          },
          skipNextPaginationFetch:true
        }));
        // this.handleResetPagination()
        const request = removeNullFields({
            ...this.state.filterData,
            startDateSL: this.state.filterData?.startDateSL
                ? Moment(this.state.filterData?.startDateSL).format("YYYY-MM-DD")
                : null,
            endDateSL: this.state.filterData?.endDateSL
                ? Moment(this.state.filterData?.endDateSL).format("YYYY-MM-DD")
                : null,
            kodeVarian: getValueFromDDL(this.state.filterData, "kodeVarian"),
            kodeWarna: getValueFromDDL(this.state.filterData, "kodeWarna"),
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: false,
            submittedFilterData: request,
            loading: false,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleClickSearch = async (e) => {
        e.preventDefault();
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            filterData: {},
        }));
        // this.handleResetPagination()
        const request = removeNullFields({
            startDateSL: this.state.searchData?.startDateSL
                ? moment(this.state.searchData?.startDateSL, 'YYYY-MM-DD').format("YYYY-MM-DD")
                : null,
            endDateSL: this.state.searchData?.endDateSL
                ? moment(this.state.searchData?.endDateSL, 'YYYY-MM-DD').format("YYYY-MM-DD")
                : null,
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: request,
            loading: false,
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {
                ...prevValue.searchData,
                [name]: value,
            },
        }));
    };

    handleCabangChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
            filterData: {},
            searchData: {
                ...this.slDateInitialValue,
            },
            loading: true,
        }));
        this.handleResetPagination()
        await this.fetchData({
            kodeCabang: value.value,
            startDateSL: this.formatDate(),
            endDateSL: this.formatDate(),
        });
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
        }));
    };

    handlePrint = async () => {
        this.handleTriggerLoading()
        try {
            const res = await Api.create("NAGAMAS_DGI_FILE").downloadReceivingUnitDGIExcel({
                filter: {
                    kodeCabang: this.state.kodeCabang.value,
                }
            });
            if(res.ok){
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                saveAs(blob, 'RECEIVING_UNIT_DGI.xlsx')
            }
        } catch (error) {
            console.log(error)
        }
        this.handleTriggerLoading()
    };

    render() {
        return (
            <>
                <ReceivingUnitDGISearch
                    state={this.state}
                    onSubmit={this.handleClickSearch}
                    onShowFilter={this.handleModalFilterVisibility}
                    onValueChange={this.handleValueChange}
                    onCabangChange={this.handleCabangChange}
                    menuAccess={this.props.menuAccess}
                />
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.tableColumns}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    footerAdditionalButtons={
                        <SimpleButton onClick={this.handlePrint}>
                            Cetak
                        </SimpleButton>
                    }
                />
                {this.state.filterVisible && (
                    <ReceivingUnitDGIFilter
                        state={this.state}
                        onSetState={this.handleStateChange}
                        onClickClose={this.handleModalFilterVisibility}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.detailVisible && (
                    <ReceivingUnitDGIDetail
                        state={this.state}
                        onShowModal={(action) => this.handleModalDetailVisibility(null,action)}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                {this.state.printVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
            </>
        );
    }
}

export default ReceivingUnitDGI;
